var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Modal } from '../Modal/Modal';
import { LoaderBars } from '../LoaderBars';
import { InputWithLabel } from '../InputWithLabel';
import { TextAreaWithLabel } from '../TextAreaWithLabel';
import { postFeedback } from '../../requests';
import { useGlobalDispatch } from '../../hooks';
import { GlobalModals } from './Header';
export function FeedbackModal(props) {
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var closeDropDown = props.closeDropDown, appName = props.appName;
    var globalDispatch = useGlobalDispatch();
    useEffect(function () {
        closeDropDown();
    }, []);
    var _b = useState({ subject: '', message: '' }), feedback = _b[0], setFeedback = _b[1];
    var closeModal = props.closeModal;
    function modifiedClosedModal() {
        if (saving)
            return;
        closeModal();
    }
    function saveData() {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!saving) return [3 /*break*/, 4];
                        if (!feedback.subject || !feedback.message) {
                            globalDispatch({
                                type: 'display message',
                                payload: {
                                    type: 'error',
                                    message: 'Please provide a subject and a message.'
                                }
                            });
                            throw new Error('missing values');
                        }
                        setSaving(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // save feedback via api
                        return [4 /*yield*/, postFeedback(feedback.subject, feedback.message, appName)];
                    case 2:
                        // save feedback via api
                        _a.sent();
                        globalDispatch({
                            type: 'set modal active',
                            payload: {
                                modal: GlobalModals.Confirm,
                                state: {
                                    header: 'Thanks for taking the time to provide your feedback!',
                                    message: 'Your feedback has been submitted to our team and we will be reviewing it shortly.'
                                }
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        globalDispatch({
                            type: 'display message',
                            payload: { type: 'error', message: 'Failed to submit feedback.' }
                        });
                        setSaving(false);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function inputChange(target) {
        return function (event) {
            var val = event.target.value;
            setFeedback(function (fb) {
                var _a;
                return (__assign(__assign({}, fb), (_a = {}, _a[target] = val, _a)));
            });
        };
    }
    function areaInputChange(target) {
        return function (event) {
            var val = event.target.value;
            setFeedback(function (fb) {
                var _a;
                return (__assign(__assign({}, fb), (_a = {}, _a[target] = val, _a)));
            });
        };
    }
    return (_jsx(Modal, __assign({ noOffClickClose: true, closeModal: modifiedClosedModal, saveData: saveData, title: 'Send Feedback', overrideSave: 'Submit', noCancelButton: true, buttonPosition: 'center' }, { children: _jsxs(StyledDesignationModal, __assign({ saving: saving }, { children: [_jsx("div", { children: _jsxs("form", { children: [_jsx(InputWithLabel, { label: 'SUBJECT', maxLength: 500, onChange: inputChange('subject'), placeholder: 'Summary of your observation...', className: 'modal-input' }, void 0),
                            _jsx(TextAreaWithLabel, { label: 'MESSAGE', maxLength: 2500, 
                                // value={currentAddress.city}
                                onChange: areaInputChange('message'), placeholder: 'Provide as many details as possible...', className: 'modal-input' }, void 0)] }, void 0) }, void 0),
                saving ? (_jsx("div", __assign({ className: 'modal-load-bars-container' }, { children: _jsx(LoaderBars, {}, void 0) }), void 0)) : null] }), void 0) }), void 0));
}
var StyledDesignationModal = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  margin-top: 30px;\n\n  .modal-load-bars-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n  }\n  .modal-input {\n    margin-top: 15px;\n    margin-bottom: 5px;\n  }\n  form {\n    ", "\n    max-width: 600px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 0 auto;\n  }\n"], ["\n  position: relative;\n  height: 100%;\n  margin-top: 30px;\n\n  .modal-load-bars-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n  }\n  .modal-input {\n    margin-top: 15px;\n    margin-bottom: 5px;\n  }\n  form {\n    ", "\n    max-width: 600px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 0 auto;\n  }\n"])), function (_a) {
    var saving = _a.saving;
    return (saving ? 'opacity: 0;' : '');
});
var templateObject_1;
